import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './assets/css/index.css';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(new URL('service-worker.js', import.meta.url)).then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
      }).catch(error => {
        console.error('Service Worker registration failed:', error);
      });
    });
  }
  

const root = createRoot(document.getElementById("root"));
root.render(
    <App/>
);
